const text = value => String(value ?? '').toLocaleLowerCase();

export function matchesFilter(value, item) {
  const cell = text(value);
  const wanted = text(item.value);
  switch (item.operator) {
    case 'isEmpty': return cell === '';
    case 'isNotEmpty': return cell !== '';
    case 'equals': return cell === wanted;
    case 'doesNotEqual': return cell !== wanted;
    case 'startsWith': return cell.startsWith(wanted);
    case 'endsWith': return cell.endsWith(wanted);
    case 'isAnyOf': return Array.isArray(item.value) && item.value.map(text).includes(cell);
    case 'doesNotContain': return !cell.includes(wanted);
    default: return cell.includes(wanted);
  }
}

export function filterRows(rows, columns, { search = '', column = '', value = '', gridFilter = { items: [] } } = {}) {
  return rows.filter(row => {
    if (search && !columns.some(c => text(row.data[c.id]).includes(text(search)))) return false;
    if (value && !(column ? [column] : columns.map(c => c.id)).some(id => text(row.data[id]).includes(text(value)))) return false;
    const items = gridFilter.items.map(item => ({ ...item, field: item.field.startsWith('cell:') ? item.field.slice(5) : item.field }))
      .filter(item => columns.some(c => c.id === item.field)
      && (item.value !== undefined || ['isEmpty', 'isNotEmpty'].includes(item.operator)));
    if (!items.length) return true;
    const matches = items.map(item => matchesFilter(row.data[item.field], item));
    return gridFilter.logicOperator === 'or' ? matches.some(Boolean) : matches.every(Boolean);
  });
}
